/**
 * Locale-aware date formatting utility
 * FR-024: Format dates according to user's locale (DD/MM/YYYY for Czech)
 */

export function formatDate(isoDate: string, locale?: string): string {
  const userLocale = locale || navigator.language || 'cs-CZ';
  
  try {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      return isoDate; // Return original if invalid
    }

    // For Czech locale, explicitly use DD/MM/YYYY format
    if (userLocale.startsWith('cs')) {
      return new Intl.DateTimeFormat('cs-CZ', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
    }

    // For other locales, use their default format
    return new Intl.DateTimeFormat(userLocale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).format(date);
  } catch (error) {
    console.error('Date formatting error:', error);
    return isoDate; // Fallback to original
  }
}

export function formatDateTime(isoDate: string, locale?: string): string {
  const userLocale = locale || navigator.language || 'cs-CZ';
  
  try {
    const date = new Date(isoDate);
    if (isNaN(date.getTime())) {
      return isoDate;
    }

    return new Intl.DateTimeFormat(userLocale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch (error) {
    console.error('DateTime formatting error:', error);
    return isoDate;
  }
}
